import {FC} from 'react'
import {UseFormReturn} from 'react-hook-form'
import {useTranslation} from '@/translations/i18n'
import {Text} from '@/components/ui/text/Text'
import {XCloseIcon} from '@/components/ui/icon/Icon'
import {MailerFormValidationSchema} from '@/features/mailer/types'
import {useActiveMailerFilters} from '@/features/mailer/hooks/useActiveMailerFilters'
import {StyledFilterBar, StyledFilterChipList, StyledFilterChip, StyledClearAll} from './style'

interface MailerActiveFiltersBarProps {
    form: UseFormReturn<MailerFormValidationSchema>
}

export const MailerActiveFiltersBar: FC<MailerActiveFiltersBarProps> = ({form}) => {
    const {t} = useTranslation()
    const {patient, consultant, clearAll} = useActiveMailerFilters(form)
    const all = [...patient, ...consultant]

    if (all.length === 0) return null

    return (
        <StyledFilterBar>
            <Text size="textXs" weight={600}>
                {t('mailer:active_filters_label')}
            </Text>
            <StyledFilterChipList>
                {all.map(f => (
                    <StyledFilterChip key={f.key} type="button" onClick={f.onRemove} aria-label={`Rimuovi ${f.label}`}>
                        {f.label}
                        <XCloseIcon size={12} />
                    </StyledFilterChip>
                ))}
            </StyledFilterChipList>
            <StyledClearAll type="button" onClick={clearAll}>
                {t('mailer:clear_all_filters')}
            </StyledClearAll>
        </StyledFilterBar>
    )
}
